// extracted by mini-css-extract-plugin
export default {"authorContainer":"bl_fH","authorName":"bl_fJ","authorDataContainer":"bl_fK","prefix":"bl_fL","authorTitle":"bl_fM","reviewerTitle":"bl_fN"};